import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableInstance } from 'react-table';

import { NumberingLogic } from '@work4all/models/lib/Classes/NumberingLogic.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { IEntityTable } from '../entity-table/EntityTable';
import { EntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/numbering-logic-table-schema.json';

import { ObjTypeCell } from './components/ObjTypeCell';

export const NumberingLogicTable = React.forwardRef<
  TableInstance,
  IEntityTable
>(function NumberingLogicTable(_props) {
  const { t } = useTranslation();

  const { entity: entityType } = schema as never;
  const tableProps = {
    schema: schema as never,
  };

  const dataTable = useEntityDataTableV8<NumberingLogic, never>({
    ...tableProps,
    customSort: {
      field: 'id',
      transform: (value: number) => t(`NUMBERINGLOGIC.${value}`),
      direction: SortDirection.ASCENDING,
    },
    cells: {
      ObjTypeCell,
    },
  });

  return (
    <EntityTableV8
      entityType={entityType}
      {...dataTable}
      {..._props}
      actions={{
        add: undefined,
        remove: undefined,
        groupingEnabled: false,
        createWidget: false,
      }}
      overrides={{
        areas: {
          left: null,
          right: null,
        },
      }}
      hideSearch
    />
  );
});
